export class BootstrapOpenMenuHover {

  /**
   * Constructor.
   */
  constructor() {
    this.windowWidth = window.innerWidth;
    this.mobileBreakPoint = 991; // Put your menu break point here, when it switches to a hamburger icon.
    this.dropdownNavItems = document.querySelectorAll(".dropdown-toggle.nav-link");
    this.dropdownMenuItems = document.querySelectorAll(".dropdown-menu");

    this.setEventListeners();
  }

  /**
   * Set all of our event listeners.
   */
  setEventListeners() {
    const _self = this;

    // To be safe set the width once the dom is loaded.
    window.addEventListener('load',  function () {
      _self.windowWidth = window.innerWidth;
    });

    // Keep track of the width in the event of a resize.
    window.addEventListener('resize',  function () {
      _self.windowWidth = window.innerWidth;
    });

    // Bind our hover events.
    if (_self.dropdownNavItems !== null)  {
      for (let i = 0; i < _self.dropdownNavItems.length; i++) {

        // On mouse enter.
        _self.dropdownNavItems[i].addEventListener('mouseenter', function () {
          if (_self.windowWidth >= _self.mobileBreakPoint) {
            this.classList.add('show');
            this.ariaExpanded = true;
            this.dataset.bsToggle = null;

            // Update the .dropdown-menu
            this.nextElementSibling.classList.add('show');
            this.nextElementSibling.dataset.bsPopper = 'none';
          }
        });

        // On mouse leave.
        _self.dropdownNavItems[i].addEventListener('mouseleave', function () {
          if (_self.windowWidth >= _self.mobileBreakPoint) {
            this.classList.remove('show');
            this.ariaExpanded = false;
            this.dataset.bsToggle = 'dropdown';

            // Update the .dropdown-menu
            this.nextElementSibling.classList.remove('show');
            this.nextElementSibling.dataset.bsPopper = null;
          }
        });
      }
    }

    // Bind events to .dropdown-menu items.
    if (_self.dropdownMenuItems !== null) {
      for (let i = 0; i < _self.dropdownMenuItems.length; i++) {
        // On mouse enter.
        _self.dropdownMenuItems[i].addEventListener('mouseenter', function () {
          if (_self.windowWidth >= _self.mobileBreakPoint) {
            this.classList.add('show');
            this.dataset.bsPopper = 'none';

            // Update the .dropdown-toggle
            this.previousElementSibling.classList.add('show');
            this.previousElementSibling.ariaExpanded = true;
            this.previousElementSibling.dataset.bsToggle = null;
          }
        });

        // On mouse leave.
        _self.dropdownMenuItems[i].addEventListener('mouseleave', function () {
          if (_self.windowWidth >= _self.mobileBreakPoint) {
            this.classList.remove('show');
            this.dataset.bsPopper = null;

            // Update the .dropdown-toggle
            this.previousElementSibling.classList.remove('show');
            this.previousElementSibling.ariaExpanded = false;
            this.previousElementSibling.dataset.bsToggle = 'dropdown';
          }
        });
      }
    }
  }
}

const bootstrapOpenMenuHover = new BootstrapOpenMenuHover();